import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { LegendWrapper, LegendContainer, LegendItem, ColorBox, SimpleButton } from "./styled";

import { useToggle } from "../../../hooks/useToggle";

import { LegendProps } from "./types";

const DEFAULT_VISIBLE_ITEMS_COUNT = 8;

export const Legend: FC<LegendProps> = ({ items, toggleAlign, ...props }) => {
  const { t } = useTranslation("chat");
  const [allVisible, toggleAllVisible] = useToggle(false);

  return (
    <LegendWrapper toggleAlign={toggleAlign}>
      <LegendContainer {...props}>
        {(allVisible ? [...items] : [...items].slice(0, DEFAULT_VISIBLE_ITEMS_COUNT)).map(
          ({ name, color }, legendItem: number) => (
            <LegendItem key={`legend-item-${legendItem}`}>
              <ColorBox color={color} />
              {name}
            </LegendItem>
          ),
        )}
      </LegendContainer>
      {items.length > DEFAULT_VISIBLE_ITEMS_COUNT && (
        <SimpleButton toggled={allVisible} onClick={toggleAllVisible}>
          {allVisible ? t("showLess") : t("showAll")}
        </SimpleButton>
      )}
    </LegendWrapper>
  );
};
